import { Component, input, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'iot-platform-ui-tab-content',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-template>
      <ng-content />
    </ng-template>
  `
})
export class TabContentComponent {
  cssClassName = input<string>('');

  @ViewChild(TemplateRef) public template!: TemplateRef<any>;
}
